module.exports = __webpack_public_path__ + "img/IMG_9706.ce9d7149.jpeg";